import i18n from 'i18next'
import * as Yup from 'yup'

export const getEvidenceDiaryValidationSchema = () => {
    const required = i18n.t('validation.message') as string

    return {
        propertyType: Yup.string().trim().required(required),
        area: Yup.string().trim().required(required),
        price: Yup.string().trim().required(required),
        evidenceDiarySeller: Yup.array()
            .of(
                Yup.object({
                    fullName: Yup.string().trim().required(required),
                })
            )
            .min(1, required),
    }
}
